import "./chunk-N3ETBM74.js";
const updateSession = async (token) => {
  sessionStorage.setItem("pax_Token", token);
  await fetch("/api/pax-auth-service/session", {
    headers: {
      Authorization: token,
      "Content-Type": "application/json"
    },
    method: "POST"
  });
};
const deleteSession = async () => {
  sessionStorage.removeItem("pax_Token");
  sessionStorage.removeItem("pax_Sub");
  document.cookie = `pax_AuthType=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
  await fetch("/api/pax-auth-service/session", {
    headers: {
      "Content-Type": "application/json"
    },
    method: "DELETE"
  });
};
export {
  deleteSession,
  updateSession
};
